<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true,
              multilingual: true
            }),
            new fields.Input({
              label: 'Tekst w tle',
              modelPath: [this, 'form', 'bg_title'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Podpis',
              modelPath: [this, 'form', 'subtitle'],
              multilingual: true
            })
          ]
        }
      ]
    }
  }
}
</script>
